export default "/images/e78251f9a5f657263d6ee43a03861e46.png";